import './_heading.scss';

const Heading = ({ level = 1, children, className = '', ...props }) => {
  const safeLevel = Math.min(Math.max(Number(level) || 1, 1), 6);
  const HeadingTag = `h${safeLevel}`;

  // @ts-ignore
  return (
    <HeadingTag className={`Heading ${className}`} {...props}>
      {children}
    </HeadingTag>
  );
};

export default Heading;
